/**
 * GeocodeButton Component
 *
 * Button to fetch latitude/longitude coordinates for a property address.
 * Appears in place of the map when coordinates are missing.
 */

import React, { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebase";
import { FaMapMarkerAlt, FaSpinner } from "react-icons/fa";
import PropTypes from "prop-types";
import "./GeocodeButton.scss";

export const GeocodeButton = ({
  propertyId,
  address,
  postcode,
  onSuccess,
  onError,
}) => {
  const [loading, setLoading] = useState(false);

  const handleGeocode = async () => {
    setLoading(true);

    try {
      const geocodeFunction = httpsCallable(
        functions,
        "geocodePropertyAddress"
      );
      const result = await geocodeFunction({
        propertyId,
        address,
        postcode,
      });

      if (result.data.success) {
        if (onSuccess) {
          onSuccess(result.data);
        }
      }
    } catch (error) {
      console.error("Geocoding error:", error);
      if (onError) {
        onError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="geocode-button-container">
      <div className="geocode-button-content">
        <FaMapMarkerAlt className="geocode-button-icon" />
        <h3>No location data available</h3>
        <p>Fetch coordinates for this property to display it on the map</p>
        <button
          className="geocode-button"
          onClick={handleGeocode}
          disabled={loading}
        >
          {loading ? (
            <>
              <FaSpinner className="geocode-button-spinner" />
              Fetching location...
            </>
          ) : (
            <>
              <FaMapMarkerAlt />
              Fetch Location
            </>
          )}
        </button>
      </div>
    </div>
  );
};

GeocodeButton.propTypes = {
  propertyId: PropTypes.string.isRequired,
  address: PropTypes.string,
  postcode: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

export default GeocodeButton;
